export default {
	apiUrl: 'https://landlord-stage.rentalstep.co/index.php/',
};

const siteConfig = {
	siteName: 'RentalStep',
	siteIcon: 'ion-flash',
	footerText: '©2018 RentalStep',
	enableAnimatedRoute: false,
};

const stripeKeys = {
	live: 'pk_live_4kWVyyAgQqmuYU1ntmfwMpLm',
	test: 'pk_test_i6RABrtGw7vByBVuRMDVhGMN'
};

const stripeKey = process.env.NODE_ENV === 'production' ? stripeKeys.live : stripeKeys.test;


const themeConfig = {
	topbar: process.env.REACT_APP_THEME,
	sidebar: process.env.REACT_APP_THEME,
	layout: process.env.REACT_APP_THEME,
	theme: process.env.REACT_APP_THEME,
	breadCrumbTheme: process.env.REACT_APP_THEME,
	showBreadCrumb: true,
	fixedNavbar: true
};

const language = 'english';

const AlgoliaSearchConfig = {
	appId: '',
	apiKey: '',
};

const Auth0Config = {
	domain: '',
	clientID: '',
	audience: '',
	options: {
		auth: {
			autoParseHash: true,
			redirect: false,
		},
		languageDictionary: {
			title: 'Metaadmin',
			emailInputPlaceholder: 'demo@gmail.com',
			passwordInputPlaceholder: 'demodemo',
		},
		icon: '',
		theme: {
			labeledSubmitButton: true,
			logo: '',
			primaryColor: '#E14615',
			authButtons: {
				connectionName: {
					displayName: 'Log In',
					primaryColor: '#b7b7b7',
					foregroundColor: '#000000',
					icon: undefined,
				},
			},
		},
	},
};

const firebaseConfig = {
	apiKey: '',
	authDomain: '',
	databaseURL: '',
	projectId: '',
	storageBucket: '',
	messagingSenderId: '',
};

const googleConfig = {
	apiKey: 'AIzaSyCRbXTogeT5L2Yp-wwOuLzvZmlmZ3iGyu4', //
};

const mapboxConfig = {
	tileLayer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	maxZoom: 18,
	defaultZoom: 11,
	center: [0, 0],
};

const youtubeSearchApi = '';

const instagramConfig = {
	instagramUserInfoApiUrl:
		'https://api.instagram.com/v1/users/self/?access_token=',
	instagramUserMediaApiUrl:
		'https://api.instagram.com/v1/users/self/media/recent/?access_token=',
	accessToken: '',
};

const jwtConfig = {
	fetchUrl: '',
	secretKey: '',
};

const getEnvUrls = () => {
	const protocol = process.env.REACT_APP_ENV === 'local' ? 'http' : 'https';
	const telfordAuthPrefix = process.env.REACT_APP_THEME === 'telford' ? 'telford-' : '';
	const telfordPrefix = process.env.REACT_APP_THEME === 'telford' ? '-telford' : '';
	const authSuffix = (process.env.REACT_APP_ENV === "prod") ? "" : "-stage";
	const suffix = (process.env.REACT_APP_ENV === "prod" || process.env.REACT_APP_ENV === 'local') ? "" : "-stage";

	const authDomain = `https://${telfordAuthPrefix}auth-landlord${authSuffix}.rentalstep.co`;
	const apiDomain = process.env.REACT_APP_ENV === 'local' ? `${protocol}://localhost` : `${protocol}://api${telfordPrefix}${suffix}.rentalstep.co`;
	
	return {
		authUrl: authDomain,
		apiUrl: apiDomain
	};
};

export const getApiUrl = getEnvUrls();

const apiUrls = {
	login: `${getApiUrl.authUrl}/index.php/auth/login`,
	signup: `${getApiUrl.authUrl}/index.php/auth/signup`,
	confirmEmail: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/accountConfirm`,
	requestPasswordReset: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/landlordRequestPasswordReset`,
	changePasswordRequest: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/landlordChangePasswordRequest`,
	verifyActivation: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/landlord-verify-activation`,
	activatePassword: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/landlord-activate-password`,
	changePassword: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordChangePassword`,
	updateExtendedProfile: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/updateExtendedProfile`,
	getUserProfile: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getUserProfile`,
	getLandlordDashboard: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetDashboard`,
	addProperty: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/addProperty`,
	listProperties: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getPropertiesNew`,
	getProperty: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getPropertyByHash`,
	getLandlordPropertySlotData: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getLandlordPropertySlotData`,
	joinExcellenceProgramme: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/joinExcellenceProgramme`,
	getPropertyHmo: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyHmoDetails`,
	getPropertyDetails: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyDetails`,
	getPropertyRentalDetails: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyRentalData`,
	updateProperty: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/updateProperty`,
	updatePropertyHmo: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordUpdatePropertyHmoDetails`,
	updatePropertyDetails: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordUpdatePropertyDetails`,
	updatePropertyRentalDetails: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordUpdateRentalData`,
	getPropertyImages: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyImagesByHash`,
	getPropertyListing: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyDetailsByHash`,
	updatePropertyListing: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/createPropertyListing`,
	epcLookup: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/epcLookup`,
	hmoLookup: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/getHmoStatus`,
	inviteTenant: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordInviteTenantReference`,
	addTenant: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordInviteTenant`,
	listTenants: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetInvitedTenants`,
	inviteTenant: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordInviteTenantReference`,
	removeTenantInvite: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/remove-tenant-invite`,
	reorderImages: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/reorderImages`,
	propertyImageUpload: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/propertyImageUpload`,
	setImageDeleted: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/setImageDeleted`,
	getLandlordIssueReports: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getLandlordIssueReports`,
	getIssueReport: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getIssueReport`,
	landlordResolveIssue: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordResolveIssue`,
	// getIssueReportImages: `${getApiUrl.apiUrl}/app_dev.php/api/tenantGetIssueImages`,
	getPropertyPreferences: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getPropertyPreferences`,
	getPropertyPreferencesSingle: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getPropertyPreferencesSingle`,
	landlordSaveEntityPreferences: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordSaveEntityPreferences`,
	addPropertyPreferenceSingle: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/addPropertyPreferenceSingle`,
	deletePropertyPreferenceSingle: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/deletePropertyPreferenceSingle`,
	landlordMakeStripePayment: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordMakeStripePayment`,
	landlordMakeStripeSubscriptionPayment: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/startPropertySubscription`,
	landlordAddPropertyToPortalQueue: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordAddPropertyToPortalQueue`,
	landlordRemovePropertyFromPortalQueue: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordDeListPropertyOnRightmoveByRentalHash`,
	getListingPrice: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/getPrice`,
	landlordGetLandlordReference: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/landlordGetLandlordReference`,
	landlordUpdateLandlordReference: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/landlordUpdateLandlordReference`,
	addPropertyPreference: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/addPropertyPreference`,
	deletePropertyPreference: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/deletePropertyPreference`,
	createAstForLandlord: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/createAstForLandlord`,
	getAstForLandlord: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getAstForLandlord`,
	updateTenancyAgreement: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/updateTenancyAgreement`,
	landlordGetOutstandingReferences: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetOutstandingReferences`,
	landlordGetTenantReference: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetTenantReference`,
	// getPropertyAstList: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getPropertyAstList`,
	getAllAstList: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getAllAstList`,
	landlordRemoveAst: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordRemoveAst`,
	landlordSignTenancyAgreement: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordSignTenancyAgreement`,
	getRentVerifyDetails: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/getRentVerifyDetails`,
	verifyPayment: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/verifyPayment`,
	declinePayment: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/declinePayment`,
	getLandlordAddressBook: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getLandlordAddressBook`,
	getInboxV2: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getInboxV2`,
	getBucketCounts: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getBucketCounts`,
	sendReplyToThread: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/sendReplyToThread`,
	sendMessage: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/sendMessage`,
	sentMessages: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getSentMessagesV2`,
	archiveThread: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordAddThreadArchivingV2`,
	unArchiveThread: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordRemoveThreadArchivingV2`,
	markThreadRead: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordMarkThreadAsReadByUserV2`,
	getPropertyViewings: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getLandlordPropertyViewingBookings`,
	confirmPropertyViewing: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordConfirmPropertyViewing`,
	confirmRescheduledPropertyViewing: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordRescheduleConfirm`,
	landlordRescheduleBooking: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordRescheduleBooking`,
	landlordCancelBooking: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordCancelViewingBooking`,
	getLandlordRentVerificationsBulk: `${getApiUrl.apiUrl}/app_dev.php/noauth-api/getLandlordRentVerificationsBulk`,
	removePropertyRentalTenant: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/removeRentalTenant`,
	updateTenantRentalLink: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/updateTenantRentalLink`,
	addPropertyRentalTenant: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/addRentalTenant`,
	getPropertyRentalTenants: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getPropertyRentalTenants?indexByTenantId=1`,
	updateRentalData: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordUpdateRentalData`,
	getRentalData: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyRentalData`,
	addRentalData: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordAddRentalData`,
	setLandlordAddress: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/setLandlordAddress`,
	getLandlordAddress: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/getLandlordAddresses`,
	propertyDocumentUpload: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/propertyDocumentUpload`,
  propertyDocumentRemove: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/removePropertyDocument`,
	cancelPropertySubscription: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordCancelPropertySubscription`,
	getNotifications: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-get-notifications`,
	loadActioned: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-get-actioned-notifications`,
	loadUnactioned: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-get-unactioned-notifications`,
	seeAllNotifications: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-see-notifications`,
	actionMessageNotification: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-action-message-notification`,
	getCompulsoryNotifications: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-get-compulsory-notifications`,
	actionAstNotification: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-action-ast-notification`,
	actionReferenceNotification: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlord-action-reference-notification`,
	getEnquiryGraphAndData: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordPropertyEnquiryGraphAndData`,
	getPropertyAttachments: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyDocumentsMeta`,
	getPropertyAttachment: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/landlordGetPropertyDocumentMeta`,
	propertyDocumentGroupRemove: `${getApiUrl.apiUrl}/app_dev.php/landlord-api/removePropertyDocumentGroup`,
};

const getaddressConfig = {
	API_KEY: "bYUpr6V-P0qWFmAWH3_7Zw8739",
	API_URL: "https://api.getaddress.io/find/"
};

export {
	siteConfig,
	language,
	themeConfig,
	AlgoliaSearchConfig,
	Auth0Config,
	firebaseConfig,
	googleConfig,
	mapboxConfig,
	youtubeSearchApi,
	instagramConfig,
	jwtConfig,
	apiUrls,
	getaddressConfig,
	stripeKey
};



// WEBPACK FOOTER //
// ./src/settings/index.js